import React, { Fragment } from "react";
import { fetch } from '@fishx/rest';
import { message } from '@whalecloud/fdx';
import { set } from "dot-prop-immutable";
import CommonCodeDrawer from '@whalecloud/page-builder-base-components/components/CommonCodeDrawer';
import { getLocale } from "@utils/util";

const valueKey = 'data.tableSettings';

const defaultURL = {
  url: 'https://mock.iwhalecloud.com/mock/2880/api/datasource'
}

const DataSettings = ({ element, updateElement }) => {
  const messages = getLocale();

  const { tableSettings = {} } = element.data;
  const { dataSourceURL = defaultURL } = tableSettings;

  const onCreate = async (code: any) => {
    const { url, method = 'GET', params = {} } = code;
    try {
      const { data } = await fetch(url, {
        method,
        data: { ...params },
      });
      if (data) {
        const sourceList = [...data];
        const propName = `${valueKey}.dataSource`;
        let newElement = set(element, propName, sourceList);
        newElement = set(newElement, `${valueKey}.dataSourceURL`, code);
        updateElement({
          element: newElement,
        });
        message.success(messages['PAGEBUIDER_MSG_DATA_SUCCESS']);
      } else {
        message.error(messages['PAGEBUIDER_MSG_DATA_FAIL']);
      }
    } catch (error) {
      message.error(error);
    }
  };

  const CodeDrawerProps = {
    value: JSON.stringify(dataSourceURL, null, '\t'),
    onClose: onCreate,
    title: messages['PAGEBUIDER_SETTINGS_EDIT_DATASOURCE'],
    buttonText: messages['PAGEBUIDER_SETTINGS_EDIT_DATASOURCE'],
    buttonLabel: messages['PAGEBUIDER_SETTINGS_DATASOURCE']
  }

  return (
    <Fragment>
      <CommonCodeDrawer {...CodeDrawerProps} />
    </Fragment>
  );
};

export default DataSettings;
